import { render, staticRenderFns } from "./ProjectHrus.vue?vue&type=template&id=b8af34f6&"
import script from "./ProjectHrus.vue?vue&type=script&lang=js&"
export * from "./ProjectHrus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports